import React, { useState } from "react";
import { useEffect, useCallback } from "react";
import { fget } from "../../../../API/callsAPI";
import Chart from "react-apexcharts";
import { Skeleton, Alert } from "@mui/material";

export default function TaskPageAnalyticsOverview({ projectId }) {
  const [taskAnalytics, setTaskAnalytics] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const getTaskAnalytics = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await fget({
        url: `widgets/project/${projectId}/task-completion-chart/`,
      });
      if (response.status === 200) {
        setTaskAnalytics(response.data);
      } else {
        setError("Failed to load task analytics data");
      }
    } catch (error) {
      setError(
        error.message || "An error occurred while fetching task analytics"
      );
    } finally {
      setIsLoading(false);
    }
  }, [projectId]);

  useEffect(() => {
    getTaskAnalytics();
  }, [getTaskAnalytics]);

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "32px",
        padding: "20px",
        justifyContent: "flex-start",
      }}
    >
      {!isLoading ? (
        Object.keys(taskAnalytics).map((taskType) => {
          // Skip if object is empty or all values are 0
          const hasValues =
            Object.keys(taskAnalytics[taskType]).length > 0 &&
            Object.values(taskAnalytics[taskType]).some(
              (value) => value.count !== 0
            );

          if (!hasValues) return null;

          return (
            <div
              key={taskType}
              style={{
                width: "350px",
                minHeight: "400px",
                backgroundColor: "#252A38",
                borderRadius: "8px",
                padding: "16px",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              }}
            >
              <h3
                style={{
                  color: "#ffffff",
                  marginBottom: "16px",
                  fontSize: "18px",
                  textAlign: "center",
                }}
              >
                {taskType}
              </h3>
              <Chart
                series={Object.values(taskAnalytics[taskType]).map(
                  (item) => item.count
                )}
                options={{
                  chart: {
                    id: "basic-bar",
                    background: "transparent",
                    events: {
                      legendClick: function (
                        chartContext,
                        seriesIndex,
                        config
                      ) {
                        const clickedLegend = Object.keys(
                          taskAnalytics[taskType]
                        )[seriesIndex];
                        const statusId =
                          taskAnalytics[taskType][clickedLegend].id;
                        window.open(
                          `/${projectId}/tasks/?status=${statusId}&name=${taskType}`
                        );
                      },
                    },
                  },
                  colors: Object.values(taskAnalytics[taskType]).map(
                    (item) => `rgb(${item.colour})`
                  ),
                  labels: Object.keys(taskAnalytics[taskType]),
                  legend: {
                    position: "bottom",
                    labels: {
                      colors: "#ffffff",
                    },
                  },
                  dataLabels: {
                    enabled: true,
                    formatter: function (val, opts) {
                      return opts.w.config.series[opts.seriesIndex];
                    },
                  },
                  plotOptions: {
                    pie: {
                      donut: {
                        labels: {
                          show: true,
                          name: {
                            show: true,
                            color: "#ffffff",
                          },
                          value: {
                            show: true,
                            color: "#ffffff",
                            formatter: function (val) {
                              return Math.round(val);
                            },
                          },
                          total: {
                            show: true,
                            color: "#ffffff",
                            formatter: function (w) {
                              return w.globals.seriesTotals.reduce(
                                (a, b) => a + b,
                                0
                              );
                            },
                          },
                        },
                      },
                    },
                  },
                  theme: {
                    mode: "dark",
                  },
                }}
                type="donut"
                height={350}
              />
            </div>
          );
        })
      ) : (
        <>
          {Array.from({ length: 4 }).map((_, index) => (
            <Skeleton
              key={index}
              style={{
                width: "350px",
                minHeight: "400px",
                backgroundColor: "#252A38",
                borderRadius: "8px",
                // padding: "16px",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              }}
            ></Skeleton>
          ))}
        </>
      )}
    </div>
  );
}
